import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import styled from 'styled-components';

import { FeatureFlag } from 'components/FeatureFlag';

import AiChatBot from './AiChatBot';

const AiChatBotBody = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const open = useSelector((state: any) => state.aiChatBot.open);

  const [tooltipVisible, setTooltipVisible] = React.useState(false);
  return (
    <FeatureFlag
      flags={[
        {
          key: 'ai_prototype',
          label: 'Enable eMind',
          subtext: 'Enable the beta eMind UI for AI data analysis.'
        }
      ]}
    >
      <ArrowButton
        open={open}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        onClick={() => dispatch({ type: 'AI_CHATBOT_SET_OPEN', payload: !open })}
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.2 1.12564V0.105764C8.2 0.0173654 8.08353 -0.0314517 8.00487 0.0226428L1.18607 4.66818C1.12814 4.70748 1.08126 4.7578 1.04901 4.8153C1.01676 4.87281 1 4.93598 1 5C1 5.06402 1.01676 5.12719 1.04901 5.1847C1.08126 5.2422 1.12814 5.29252 1.18607 5.33182L8.00487 9.97736C8.08504 10.0315 8.2 9.98263 8.2 9.89424V8.87436C8.2 8.80971 8.16521 8.7477 8.10773 8.70811L2.66237 5.00066L8.10773 1.29189C8.16521 1.2523 8.2 1.19029 8.2 1.12564Z"
            fill="#2665EE"
          />
        </svg>
      </ArrowButton>
      <ShadowDiv
        open={open}
        onClick={() => dispatch({ type: 'AI_CHATBOT_SET_OPEN', payload: true })}
      />
      {tooltipVisible && !open && <AiTooltip>Ask eMind AI</AiTooltip>}
      <AiChatBot />
    </FeatureFlag>
  );
};
export default AiChatBotBody;

const ArrowButton = styled.button<{
  open?: boolean;
}>`
  position: absolute;
  top: 50%;
  left: ${({ open }) => (open ? '11px' : '-11px')};
  border-radius: ${({ open }) => (open ? ' 0 4px 4px 0' : '4px 0 0 4px')};
  transform: translate(-50%, -50%);
  background: linear-gradient(0deg, #ede9fe 0%, #d6eff9 100%);
  border: 1px solid #e8e8e8;
  border-left: ${({ open }) => (open ? '0px' : '1px')};
  border-right: ${({ open }) => (open ? '1px' : '0px')};
  width: 22px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  z-index: 101;
  padding: 0;
  svg {
    transition: transform 0.2s;
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
  &:hover svg {
    transform: ${({ open }) =>
      open ? 'rotate(180deg) translateX(-3px)' : 'rotate(0deg) translateX(-3px)'};
  }
`;
const ShadowDiv = styled.div<{
  open?: boolean;
}>`
  position: absolute;
  top: 0%;
  left: -14px;
  width: 14px;
  height: 100vh;
  z-index: 100;
  transition: background 0.3s;
  display: ${({ open }) => (!open ? 'block' : 'none')};
  pointer-events: ${({ open }) => (!open ? 'auto' : 'none')};
  cursor: pointer;
  background: linear-gradient(to left, transparent, transparent);

  &:hover {
    background: linear-gradient(to left, rgba(0, 0, 0, 0.23), transparent);
  }
`;

const AiTooltip = styled.span`
  position: absolute;
  top: 50%;
  left: -84px;
  border-radius: 4px;
  transform: translate(-50%, -50%);
  background: #595959;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  z-index: 101;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.6%;
  color: #ffffff;
  box-shadow: 0px 2px 8px 0px #00000026;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    transform: translateY(-50%);
    border-width: 6px 0 6px 8px;
    border-style: solid;
    border-color: transparent transparent transparent #595959;
    display: block;
  }
`;
